<template>
  <router-link
    class="home-progress-course-card border-0"
    :to="{
      name: 'lesson',
      params: { ...lesson.course, lesson: lesson.id }
    }"
  >
    <div
      class="img"
      :style="`background-image: url(${lesson.picture || lesson.course.cover})`"
    ></div>

    <div class="progress mb-1 flex-fill">
      <div
        class="progress-bar bg-primary"
        role="progressbar"
        :style="`width: ${progress}%`"
      ></div>
    </div>

    <small class="d-flex">
      <strong class="course-title">
        {{ lesson.course.title }}
      </strong>
    </small>

    <h6 class="text-light" v-if="lesson">
      {{ lesson.name }}
    </h6>
  </router-link>
</template>

<script>
export default {
  props: {
    lesson: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    progress() {
      if (!this.lesson.duration) return 0;
      const durationArray = this.lesson.duration.split(":");
      const seconds =
        parseInt(durationArray[0]) * 60 * 60 +
        parseInt(durationArray[1]) * 60 +
        parseInt(durationArray[2]);
      return Math.round((100 * this.lesson.progress.stopped_at) / seconds);
    }
  },
  methods: {
    onClick() {
      this.$router.push({
        name: "course",
        params: {
          ...this.lesson.course
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.home-progress-course-card {
  text-align: left;
  padding: 0;
  border-radius: 16px;
  width: 100%;

  &:hover {
    opacity: 0.8;
    text-decoration: none;
  }

  .img {
    height: 0;
    width: 100%;
    display: block;
    padding-bottom: 55%;
    background-size: cover;
    background-position-x: center;
    background-position-y: center;
    margin-bottom: -8px;
  }

  .progress {
    height: 8px;
    width: 100%;
    border-radius: 0;
    background: none;
  }

  .course-title {
    font-size: 14px;
    text-overflow: ellipsis;
    min-width: 0;
    margin-right: 8px;
    overflow: hidden;
  }

  small {
    color: rgba(160, 220, 250, 0.8);
  }
}
</style>
